import { render, staticRenderFns } from "./header-tools.vue?vue&type=template&id=f06c60b2&"
import script from "./header-tools.vue?vue&type=script&lang=js&"
export * from "./header-tools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports